import React, { Component } from 'react';
import { Col, Form, Row, Spin } from 'antd';

import InfoBtn from '../InfoBtn/InfoBtn';
import * as consultantController from '../../services/api/consultant';
import './ConsultantInfoBtn.scss'

const FormItem = Form.Item;

export default class ConsultantInfoBtn extends Component {
    constructor(props) {
        super(props);

        this.state = {
            consultant: {},
            isLoading: false
        }
    }

    fetchConsultant() {
        const { consultantId } = this.props;

        if (consultantId) {
            this.setState({ isLoading: true });

            consultantController.getConsultant(consultantId)
                .then((res) => res.json())
                .then((json) => this.setState({ consultant: json, isLoading: false }))
        }
    }

    handleVisibleChange(visible) {
        if (visible)
            this.fetchConsultant()
    }

    renderContent() {
        const { consultant, isLoading } = this.state;
        const { name, username, email } = consultant;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 12 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 12 },
            },
        };

        if (isLoading)
            return (<Spin/>)
        else
            return (
                <Form className="ConsultantInfoForm">
                    <Row gutter={32}>
                        <Col span={24}>
                            <FormItem {...formItemLayout} label="Name">
                            	<span>{name}</span>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={24}>
                            <FormItem {...formItemLayout} label="Username">
                                <span>{username}</span>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={24}>
                            <FormItem {...formItemLayout} label="Email">
                            	<span>{email}</span>
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
            )
    }

    render() {
        return (
            <InfoBtn
				content={this.renderContent()}
				onVisibleChange={(visible) => this.handleVisibleChange(visible)}
			/>
        );
    }
}

ConsultantInfoBtn.defaultProps = {
    consultantId: ''
};


// WEBPACK FOOTER //
// ./src/components/ConsultantInfoBtn/ConsultantInfoBtn.js